/** Checklist tipo OT ID — the PROGRAMADO (planned/scheduled) type in the database */
export const TIPO_OT_CHECKLIST = 1 as const;

/** NPL (No Planificada) tipo OT ID in the database */
export const TIPO_OT_NPL = 2 as const;

/** SGM tipo OT ID — also treated as NPL in the frontend */
export const TIPO_OT_NPL_SGM = 6 as const;

/** All tipo OT IDs that trigger NPL validation and auto-assign */
export const NPL_TIPO_OT_IDS: readonly number[] = [TIPO_OT_NPL, TIPO_OT_NPL_SGM];

/** Default pauta ID auto-assigned to NPL tickets */
export const NPL_DEFAULT_PAUTA_ID = 100 as const;

/**
 * Equipment subtype for Baja Tensión (EBTC) NPL tickets.
 *
 * BT NPL correlativos split by equipment kind, encoded as a digit prepended to
 * the MMYY in the legacy production scheme:
 *   - ELECTRICO → `EBTC-9<MMYY><seq>` (e.g. EBTC-90226107)
 *   - AIRE      → `EBTC-8<MMYY><seq>` (e.g. EBTC-80226101)
 * Instrumentación NPL has no such split (it uses a global running counter), so
 * the selector is BT-only — see NPL_EQUIPO_SELECTOR_AMBITO_IDS in `ambitos.ts`.
 */
export const NPL_EQUIPO_TIPO = {
  ELECTRICO: 'ELECTRICO',
  AIRE: 'AIRE',
} as const;

export type NplEquipoTipo = (typeof NPL_EQUIPO_TIPO)[keyof typeof NPL_EQUIPO_TIPO];

// Derived from the const object (not re-listed) so a new variant auto-extends the
// runtime list, and frozen like NPL_EQUIPO_DIGITO below.
export const NPL_EQUIPO_TIPOS: readonly NplEquipoTipo[] = Object.freeze(
  Object.values(NPL_EQUIPO_TIPO),
);

/** Runtime narrowing guard: is an arbitrary string a valid NPL equipment subtype? */
export function isNplEquipoTipo(value: string): value is NplEquipoTipo {
  return (NPL_EQUIPO_TIPOS as readonly string[]).includes(value);
}

/**
 * Correlativo digit prepended to the MMYY for each BT NPL equipment subtype.
 * Anchored to the legacy production scheme (eléctrico→9, aire→8). Single source
 * of truth consumed by the correlativo generator — do not hardcode 8/9 elsewhere.
 */
export const NPL_EQUIPO_DIGITO: Readonly<Record<NplEquipoTipo, string>> = Object.freeze({
  [NPL_EQUIPO_TIPO.ELECTRICO]: '9',
  [NPL_EQUIPO_TIPO.AIRE]: '8',
});
